function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M12 10.586l6.364-6.364 1.414 1.414L13.414 12l6.364 6.364-1.414 1.414L12 13.414l-6.364 6.364-1.414-1.414L10.586 12 4.222 5.636l1.414-1.414L12 10.586z",
  id: "close_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("use", {
  fill: "#000",
  xlinkHref: "#close_svg__a",
  fillRule: "evenodd"
});

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5JY29ucy9jbG9zZTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxwYXRoIGQ9Ik0xMiwxMC41ODU3ODY0IEwxOC4zNjM5NjEsNC4yMjE4MjU0MSBMMTkuNzc4MTc0Niw1LjYzNjAzODk3IEwxMy40MTQyMTM2LDEyIEwxOS43NzgxNzQ2LDE4LjM2Mzk2MSBMMTguMzYzOTYxLDE5Ljc3ODE3NDYgTDEyLDEzLjQxNDIxMzYgTDUuNjM2MDM4OTcsMTkuNzc4MTc0NiBMNC4yMjE4MjU0MSwxOC4zNjM5NjEgTDEwLjU4NTc4NjQsMTIgTDQuMjIxODI1NDEsNS42MzYwMzg5NyBMNS42MzYwMzg5Nyw0LjIyMTgyNTQxIEwxMiwxMC41ODU3ODY0IFoiIGlkPSJwYXRoLTEiPjwvcGF0aD4KICAgIDwvZGVmcz4KICAgIDxnIGlkPSJJY29ucy9jbG9zZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNwYXRoLTEiPjwvdXNlPgogICAgICAgIDwvbWFzaz4KICAgICAgICA8dXNlIGlkPSJTaGFwZSIgZmlsbD0iIzAwMDAwMCIgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgClose as ReactComponent };